import {
  POST_ECONOMICNUMBERS_CATALOG,
  POST_ECONOMICNUMBERS_CATALOG_SUCCESS,
  POST_ECONOMICNUMBERS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const postEconomicNumbersCatalogRed = (
  state: any = false,
  actions: any
) => {
  switch (actions.type) {
    case POST_ECONOMICNUMBERS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_ECONOMICNUMBERS_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_ECONOMICNUMBERS_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
